import { useContext, useMemo, useState } from 'react';
import {
  PeopleCommunity20Regular,
  Archive20Regular,
  bundleIcon,
  PeopleCommunity20Filled,
  Archive20Filled,
  ClockLock20Filled,
  ClockLock20Regular,
} from '@fluentui/react-icons';

import { Body1 } from '@fluentui/react-components';
import { NavDrawer, NavItem } from '@shared/components';
import { Guard, SignInContext } from '..';
import { NavDrawerBody } from '@fluentui/react-nav-preview';
import { Link, Outlet, useLocation } from 'react-router-dom';

const UserManagementIcon = bundleIcon(PeopleCommunity20Filled, PeopleCommunity20Regular);
const ArchiveIcon = bundleIcon(Archive20Filled, Archive20Regular);
const AccessLogsIcon = bundleIcon(ClockLock20Filled, ClockLock20Regular);

const SettingsLayout = () => {
  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();
  const { organization } = useContext(SignInContext);
  const selectedValue = useMemo(() => location.pathname.split('/').pop(), [location.pathname]);

  return (
    <Guard onlyAdmins showInfo>
      <div className="flex flex-1">
        <NavDrawer
          type="inline"
          title="Settings"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          selectedValue={selectedValue}
          footer={
            organization.softwareVersion ? (
              <Body1 className="text-neutral-500">Version {organization.softwareVersion}</Body1>
            ) : undefined
          }
        >
          <Link to="/settings/user-management">
            <NavItem icon={<UserManagementIcon />} value="user-management">
              User management
            </NavItem>
          </Link>
          <Link to="/settings/archive">
            <NavItem icon={<ArchiveIcon />} value="archive">
              Archive
            </NavItem>
          </Link>
          <Link to="/settings/access-logs">
            <NavItem icon={<AccessLogsIcon />} value="access-logs">
              Access logs
            </NavItem>
          </Link>
          {/*<NavItem
                icon={<Key20Regular />}
                value="2"
              >
                License
              </NavItem>*/}
        </NavDrawer>
        <div className="grow h-full w-full relative">
          <div className="absolute top-0 left-0 w-full h-full overflow-y-auto pl-1 pr-3">
            <div className="pt-4 pb-16 w-full">
              <NavDrawerBody className="!pt-0 w-full">
                <Outlet />
              </NavDrawerBody>
            </div>
          </div>
        </div>
      </div>
    </Guard>
  );
};

export default SettingsLayout;
